import {type KhanFetchFn} from "./types.ts";

let overrideFn: KhanFetchFn | null = null;

/**
 * Override the default `khanFetch` implementation with a custom one.
 *
 * This is useful for testing or mocking purposes.
 * This is a no-op in production.
 */
export const setKhanFetchOverride = (fn: KhanFetchFn | null) => {
    if (process.env.NODE_ENV === "production") {
        // This is a no-op in production.
        return;
    }
    overrideFn = fn;
};

export const khanFetch: KhanFetchFn = async (input, init) => {
    if (process.env.NODE_ENV !== "production") {
        if (overrideFn) {
            // We support mocking this in Storybook and Jest.
            return overrideFn(input, init);
        }
    }
    const {internalFetch} = await import("./internal-fetch.ts");
    return internalFetch(input, init);
};
